/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowsCorners = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9.793 11.207 4.035 5.45v4.657h-2v-8.07h8.071v2H5.45l5.758 5.757zm4.743 1.914 5.364 5.364v-4.657h2V21.9h-8.072v-2h4.657l-5.364-5.364zm-.394-1.914L19.9 5.45v4.657h2v-8.07h-8.071v2h4.657l-5.758 5.757zM9.4 13.121l-5.365 5.364v-4.657h-2V21.9h8.072v-2H5.45l5.364-5.364z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgArrowsCorners as ArrowsCorners };
